import axios from 'axios';

export class UploadService {
    uploadFile = async (formData) => {
        return await axios.post('/api/upload/upload', formData);
    };

    getDownloadSamplePath = async () => {
        return await axios.get('/api/upload/downloadsamplepath');
    }
}